<template>
  <div class="newdetail_page">
    <div class="ndp_1">
      <p class="ndp_11">{{ title }}</p>
      <p class="ndp_12">{{ createTime }}</p>
      <div id="contenthtml" v-html="content">
        {{content}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newdetail_page",
  created(){
    
  },
  mounted() {
    // this.getNewDetail(this.$route.params["id"],this.$i18n.locale);
    var lan = navigator.language;
    if(lan == 'zh-CN'){
      this.getNewDetail(this.$route.params["id"],'zh')
    }else{
      this.getNewDetail(this.$route.params["id"],'en')
    }
  },
  methods: {
    getNewDetail(id,language) {
      this.$post("/halababy/loofox/branddetail", { id: id }).then((res) => {
        this.createTime = res.data["createTime"];
        if(language == 'zh'){
          this.title = res.data["title"];
          this.content = res.data["content"];
        }else{
          this.title = res.data["titleEn"];
          this.content = res.data["contentEn"];
        }
      });
    },
  },
  data() {
    return {
      title: this.title,
      createTime: this.createTime,
      content: this.content,
      
    };
  },
};
</script>

<style>
.newdetail_page {
  width: 100%;
  min-height: 800px;
  margin-bottom: 30px;
  background-color: rgb(255, 255, 255);
  z-index: 100;
}
.ndp_1 {
  width: 760px;
  margin: 0 auto;
  padding-top: 30px;
}
.ndp_1 div{
  text-align: left;
  color: #696969;
  font-family: Microsoft YaHei;
}
.ndp_11 {
  padding-top: 40px;
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ndp_12 {
  margin: 30px 0;
  text-align: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/newDetail.vue